import { defineMessages } from 'react-intl';

export default defineMessages({
  billerView: {
    id: 'billerView',
    defaultMessage: 'View Biller ',
  },
});
